import type { Identifier } from "ra-core";
import { useWatch } from "react-hook-form";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";

import { RESPONSIBLE_IN_PROJECT } from "../providers/commons/responsibleFilter";
import type { Sale } from "../types";

const saleOptionRenderer = (choice: Sale) =>
  `${choice.first_name} ${choice.last_name}`;

/**
 * «Ответственный» of a lead or deal: only people who may be responsible in
 * the record's project (the owner and the active people of the project; the
 * database refuses anyone else).
 */
export const ResponsibleInput = () => {
  const projectId = useWatch({ name: "project_id" }) as Identifier | undefined;
  return (
    <ReferenceInput
      source="sales_id"
      reference="sales"
      sort={{ field: "last_name", order: "ASC" }}
      filter={{
        "disabled@neq": true,
        ...(projectId != null ? { [RESPONSIBLE_IN_PROJECT]: projectId } : {}),
      }}
    >
      <SelectInput helperText={false} optionText={saleOptionRenderer} />
    </ReferenceInput>
  );
};
